import { put } from '../..';
import { Building } from '../../../screens/LocationManagement/components/AddBuildingModal';

const updateBuildingSettings = (building: Building) => {
  const {
    SlaHours, WorkingHours, LocationId, CountryCode, StateCode, CityName, Area, Space,
    LocationCapacity,
  } = { ...building };

  const body: any = {
    SlaHours,
    WorkingHours,
    CountryCode,
    StateCode,
    CityName,
    Floor: { IsAssetAvailable: true },
    Area,
    Space,
    Building: building.Name,
    LocationCapacity,
  };
  return put(`locations/buildings/${LocationId}`, body);
};

export default updateBuildingSettings;
